import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage/HomePage";
import { Suspense, lazy } from "react";
const AccountPage = lazy(() => import('@/pages/AccountPage/AccountPage'));
import {
  TrainingPage, DietPage, CustomPage, ProfilePage, LoginPage, WorkoutPage, ExerciseDetailPage,
  CourseDetailPage, SimpleAssessmentPage, SubscribePage, CycleReportPage,
  CollectionDetailPage, DayDetailPage, ExerciseListPage, CustomPlansPage,
  CustomPlanDetailPage, TrainingCyclePage, DietPlansPage, DietPlanSelectPage,
  DetailedAssessmentPage, FenJuePage, FenJueWorkoutPage, MyTrainingPlanPage,
  MemberTrainingPlanPage, SleepPlanPage, MoodTipsPage, TrainingRecordsPage,
  WeightTrendPage, MembershipPage, RecoveryWorkoutPage, BodySignalsPage,
  DataStatsPage, SettingsPage, NotFoundPage, PlanExercisePickerPage,
} from "@/deployment/lazyPages";

// Keep saved links to the removed guide on the homepage.
function RemovedGuideRedirect() {
  return <Navigate to="/" replace />;
}

// 旧路径兼容重定向 wrapper：/diet-assessment → /simple-assessment
function DietAssessmentRedirect() {
  return <Navigate to="/simple-assessment" replace />;
}

// 动作库首页重定向：直接进入胸部动作库
function ExerciseLibraryRedirect() {
  return <Navigate to="/exercise-library/chest" replace />;
}

// 旧路径兼容重定向 wrapper：/weekly-report → /training-records?tab=weekly
function WeeklyReportRedirect() {
  return <Navigate to="/training-records?tab=weekly" replace />;
}

// 数据统计页周报Tab重定向 wrapper：/data-stats?tab=weekly → /training-records?tab=weekly
function DataStatsRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  if (tab === 'weekly') {
    return <Navigate to="/training-records?tab=weekly" replace />;
  }
  return <DataStatsPage />;
}

export default function App() {
  return (
    <Suspense fallback={<div className="app-bg min-h-screen flex items-center justify-center" role="status">正在加载页面…</div>}>
    <Routes>
      <Route path="account" element={<AccountPage />} />
      <Route element={<Layout />}>
        <Route path="first-day" element={<RemovedGuideRedirect />} />
        <Route index element={<HomePage />} />
        <Route path="training" element={<TrainingPage />} />
        <Route path="diet" element={<DietPage />} />
        <Route path="custom" element={<CustomPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="workout/:dayId?" element={<WorkoutPage />} />
        <Route path="exercise/:id" element={<ExerciseDetailPage />} />
        <Route path="course/:id" element={<CourseDetailPage />} />
        <Route path="collection/:system" element={<CollectionDetailPage />} />
        <Route path="day/:dayId" element={<DayDetailPage />} />
        <Route path="exercise-library" element={<ExerciseLibraryRedirect />} />
        <Route path="exercise-library/:group" element={<ExerciseListPage />} />
        <Route path="custom-plans" element={<CustomPlansPage />} />
        <Route path="custom-plans/:id" element={<CustomPlanDetailPage />} />
        <Route path="plan-picker/:planId" element={<PlanExercisePickerPage />} />
        <Route path="training-cycle" element={<TrainingCyclePage />} />
        <Route path="simple-assessment" element={<SimpleAssessmentPage />} />
        {/* 旧路径兼容：统一重定向到简易测评 */}
        <Route path="questionnaire" element={<Navigate to="/simple-assessment" replace />} />
        <Route path="diet-assessment" element={<DietAssessmentRedirect />} />
        <Route path="subscribe" element={<SubscribePage />} />
        <Route path="diet-plans" element={<DietPlansPage />} />
        <Route path="diet/plan-select" element={<DietPlanSelectPage />} />
        <Route path="detailed-assessment" element={<DetailedAssessmentPage />} />
        <Route path="cycle-report" element={<CycleReportPage />} />
        <Route path="fanjue" element={<FenJuePage />} />
        <Route path="fanjue/:project/workout" element={<FenJueWorkoutPage />} />
        <Route path="my-training-plan" element={<MyTrainingPlanPage />} />
        <Route path="member-training-plan" element={<MemberTrainingPlanPage />} />
        <Route path="sleep-plan" element={<SleepPlanPage />} />
        <Route path="mood-tips" element={<MoodTipsPage />} />
        <Route path="training-records" element={<TrainingRecordsPage />} />
        <Route path="weight-trend" element={<WeightTrendPage />} />
        <Route path="membership" element={<MembershipPage />} />
        <Route path="recovery-workout" element={<RecoveryWorkoutPage />} />
        <Route path="body-signals" element={<BodySignalsPage />} />
        <Route path="data-stats" element={<DataStatsRedirect />} />
        <Route path="weekly-report" element={<WeeklyReportRedirect />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </Suspense>
  );
}
